export default __webpack_public_path__ + "static/media/appstoreWeb.2e334f3d.svg";